module.exports = __webpack_public_path__ + "b9ace19b234dc6f26ef87fe124653046.pdf";